module.exports = __webpack_public_path__ + "static/img/forth.3ce1f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tstj/forth.png
// module id = BjxF
// module chunks = 1